<template>
  <div class="block-chain-node-manage">
    <action-bar>
      <search v-model="inputContent" placeholder="请输入节点名" @onSearch="handleSearch"></search>
    </action-bar>
    <normal-table
      ref="commonTable"
      :table-col="tableCol"
      :table-data="list"
      :operator="operator"
      :show-edit="true"
      :paging="paging"
      @pagination="handleSizeOrPageChange"
    >
    </normal-table>
    <node-detail ref="nodeDetail"></node-detail>
  </div>
</template>

<script>
import auth from '@/auth/index'
import { mapState, mapActions } from 'vuex'
import nodeDetail from './nodeDetail'
export default {
  name: 'Index',
  components: {
    nodeDetail
  },
  data() {
    return {
      inputContent: '',
      // 设置table的列
      tableCol: [
        { 
          prop: 'NodeName', 
          label: '节点名称',
          minWidth: 181 
        },
        { 
          prop: 'OrgName', 
          label: '所属组织',
          minWidth: 116 
        },
        {
          prop: 'Type',
          label: '节点类型',
          formatter: row => {
            return this.formatType(row)
          },
          minWidth: 132
        },
        { 
          prop: 'NodeId', 
          label: '节点ID',
          minWidth: 390
        },
        { 
          prop: 'NodeIp', 
          label: '节点地址',
          minWidth: 132 
        },
        { 
          prop: 'Consensus', 
          label: '账本同步类型',
          minWidth: 117
        }
      ],
      // table的基本操作
      operator: [
        {
          text: '查看',
          click: (row, col, cellValue) => {
            return this.goDetail(row)
          },
          showText: true,
          icon: 'icon-check',
          formatter: row => {
            return this.$utils.hasAuth(this.$store, auth.blockchain.checkDetail.nodeInfo.check)
          }
        }
      ],
      operateCol: {
        minWidth: 99
      }
    }
  },
  computed: {
    ...mapState({
      list: state => state.chain.chain_node_list,
      paging: state => state.chain.chain_node_paging
    })
  },
  mounted() {
    this.getList()
  },
  methods: {
    ...mapActions(['getChainNodeLists']),
    getList(limit = 10, offset = 0) {
      let params = {
        offset,
        limit,
        chainId: this.$route.query.chainId,
        name: this.inputContent
      }
      this.getChainNodeLists(params)
    },
    handleSizeOrPageChange(data) {
      const { offset, limit } = data
      this.getList(limit, offset * limit)
    },
    handleSearch(val) {
      this.inputContent = val
      this.getList()
    },
    refresh() {
      this.inputContent = ''
      this.getList()
    },
    formatType(row) {
      return row.Type === 0 ? '共识节点' : '普通节点'
    },
    goDetail(row) {
      this.$refs.nodeDetail.handleOpen(row)
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/styles/variables/theme';
@import '@/styles/variables/adaptation';

@include theme(
  'block-chain-node-manage',
  (
    --block-chain-node-manage-list-operate-color: #45c2ff,
    --block-chain-node-manage-list-operate-danger-color: #e95757
  ),
  (
    --block-chain-node-manage-list-operate-color: #45c2ff,
    --block-chain-node-manage-list-operate-danger-color: #e95757
  )
);
.block-chain-node-manage {
  @include adaptation(
    (
      --block-chain-node-manage-unavaliable-height: 166px
    )
  );
  --block-chain-node-manage-min-height: calc(
    var(--base-main-router-body-avaliable-height) - var(--block-chain-node-manage-unavaliable-height)
  );
  .btn-list-style {
    width: 100%;
  }

  .normal-table-wrap {
    height: 100%;
    min-height: var(--block-chain-node-manage-min-height);

    /deep/ {
      .el-empty {
        height: 100%;
        min-height: var(--block-chain-node-manage-min-height);
      }

      .normal-table {
        height: 100%;
        min-height: var(--block-chain-node-manage-min-height);

        .operate-item {
          color: var(--block-chain-node-manage-list-operate-color);

          &.operate-danger {
            color: var(--block-chain-node-manage-list-operate-danger-color);
          }
        }
      }
    }
  }
}
</style>
